import React, {Component} from "react";

class Statistics extends Component{
    render() {
        return (
            <div className="container mt-3 stats">
                <div className="row">

                    <div className="col-md-3">
                        <div className="card p-4">
                            <h6>
                             Bids
                            </h6>
                            <h3 >
                                _
                            </h3>

                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="card p-4">
                            <h6>
                               Cars
                            </h6>
                            <h3>
                                _
                            </h3>

                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="card p-4">
                            <h6>
                                Properties
                            </h6>
                            <h3>
                                _
                            </h3>

                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="card p-4">
                            <h6>
                                Salvages
                            </h6>
                            <h3>
                                _
                            </h3>

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default Statistics